// extracted by mini-css-extract-plugin
export default {"container":"PolicyList_container__7ahNS","buttonPageSelect":"PolicyList_buttonPageSelect__tpJ9s"};